<div class="notification-banner" *ngIf="alert">
  <div class="container-fluid d-md-none">
    <div class="row align-items-center">
      <div class="col">
        <div class="mobile-sub-text d-md-none" [innerHtml]="alert.mobile_text"></div>
        <div class="mobile-sub-description d-md-none" [innerHtml]="alert.mobile_long_text"></div>
        <div class="btn mobile-notification-banner-close" (click)="closeOnMobile()">Close</div>
      </div>
    </div>
  </div> 

  <div class="container">
    <div class="bannner-wrapper">
      <div class="new-badge-and-title">
        <div class="badge bg-primary">New</div>
        <div class="badge-title">Welcome to Talentview</div>
      </div> 
      <div class="desktop-title d-none d-md-block" [innerHtml]="alert.text"></div>
      <div class="show-description dropdown-toggle" role="button" (click)="toggleDescription()">{{ showFullDescription ? 'Hide' : 'Learn more' }}</div>
      <div class="notification-banner-close" (click)="closeOnDesktop()"><fa-icon [icon]="'faTimes' | icon"></fa-icon></div>
    </div>
    <div class="desktop-description d-none d-md-block mt-3" [innerHtml]="alert.long_text" *ngIf="showFullDescription"></div>
    <a class="desktop-description-action d-none d-md-block mt-3" [routerLink]="['/news/New-Talentview-Platform-Launch']" *ngIf="showFullDescription">Read more about it here</a>
  </div>
</div>
